// Minimal brand constants consumed by the shared (26bets-style) layout
// components. Betyakata is single-brand, so this is a static object.
const brand = {
  name: "Betyakata",
  assets: {
    logo: "/assets/images/PNG/Betyakatalogo-07.png",
    logoOnAccent: "/assets/images/PNG/Betyakatalogo-07.png",
    wordmark: "/assets/images/PNG/betyakata-wordmark.png",
  },
  legal: {
    supportEmail: "support@betyakata.com",
    socials: {
      facebook:
        "https://www.facebook.com/profile.php?id=61577232573985&mibextid=ZbWKwL",
      twitter: "https://x.com/betyakata?s=21",
      instagram:
        "https://www.instagram.com/betyakata?igsh=MXZ1emkxOXl4bnB1bg%3D%3D&utm_source=qr",
    },
  },
};

export default brand;
